import { World, Systems } from '$legacyecstatic';
import ECSWorldContext from 'contexts/ECSWorldContext';
import { Components } from 'editor/components';
import React, { FC, PropsWithChildren, useRef } from 'react';

type Props = PropsWithChildren<unknown>;

const ECSWorldProvider: FC<Props> = (props: Props) => {
  const { children } = props;

  const worldRef = useRef<World<Components>>(new World<Components>());

  return (
    <ECSWorldContext.Provider value={worldRef.current}>
      {children}
    </ECSWorldContext.Provider>
  );
};

export default ECSWorldProvider;
